export default "__VITE_PUBLIC_ASSET__1286fd85__"